export const getCampanieData = () => ({
  name: "Campanie",
  country: "Italie",
  description: "La Campanie est une région viticole du sud de l'Italie, s'étendant de la côte tyrrhénienne aux Apennins. Cette région produit principalement des vins rouges structurés et des vins blancs aromatiques, avec une forte identité locale et des cépages autochtones.",
  type: "region",
  mapAreas: [
    { region: "Campanie", x: 45, y: 55, color: "#4B164C", size: 3 }
  ],
  statistics: {
    totalArea: "41,000 ha",
    production: "2.8 million hectolitres",
    appellations: "18 DOC et 4 DOCG",
    provinces: "5 provinces",
    exportPercentage: "25%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influence continentale, étés chauds et hivers doux",
    soil: "Sols très variés : volcanique, calcaire, argile, tuf",
    viticulture: "Viticulture traditionnelle, vignobles en coteaux et en plaine"
  },
  wineStyles: {
    red: "Vins rouges structurés et tanniques, avec une forte identité cépage",
    white: "Vins blancs secs et aromatiques, frais et complexes",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sweet: "Vins doux traditionnels, vendanges tardives"
  },
  history: "La viticulture dans la Campanie remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XIXe siècle a vu l'émergence des appellations. Aujourd'hui, la région est reconnue pour ses vins de qualité et ses cépages autochtones.",
  foodPairing: "Cuisine campanienne, pizzas, poissons, charcuteries, cuisine napolitaine",
  subregions: {
    "taurasi": {
      name: "Taurasi",
      description: "Région prestigieuse produisant des vins rouges structurés et tanniques, avec une forte identité cépage.",
      characteristics: {
        climate: "Climat méditerranéen avec influence continentale",
        soil: "Sols volcaniques et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        red: ["Aglianico", "Piedirosso", "Sciascinoso"]
      },
      wineStyles: {
        "taurasi": "Vins rouges structurés et tanniques",
        "taurasi-riserva": "Vins rouges puissants et concentrés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine campanienne"
    },
    "fiano": {
      name: "Fiano",
      description: "Région produisant des vins blancs secs et aromatiques, avec une forte identité cépage.",
      characteristics: {
        climate: "Climat méditerranéen avec influence continentale",
        soil: "Sols volcaniques et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        white: ["Fiano", "Greco", "Falanghina"]
      },
      wineStyles: {
        "fiano-di-avellino": "Vins blancs secs et aromatiques",
        "greco-di-tufo": "Vins blancs secs et structurés"
      },
      foodPairing: "Poissons, fruits de mer, volailles, fromages, cuisine côtière"
    },
    "vesuvio": {
      name: "Vesuvio",
      description: "Région volcanique produisant des vins rouges et blancs de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat méditerranéen avec influence volcanique",
        soil: "Sols volcaniques et sableux",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        red: ["Piedirosso", "Aglianico", "Sciascinoso"],
        white: ["Falanghina", "Coda di Volpe", "Caprettone"]
      },
      wineStyles: {
        "vesuvio-rosso": "Vins rouges structurés et équilibrés",
        "vesuvio-bianco": "Vins blancs secs et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, fromages, cuisine traditionnelle"
    },
    "isole": {
      name: "Isole",
      description: "Région insulaire produisant des vins rouges et blancs de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat méditerranéen avec influence maritime",
        soil: "Sols volcaniques et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en terrasses"
      },
      grapeVarieties: {
        red: ["Aglianico", "Piedirosso"],
        white: ["Falanghina", "Biancolella", "Forastera"]
      },
      wineStyles: {
        "isola-dischia-rosso": "Vins rouges fruités et équilibrés",
        "isola-dischia-bianco": "Vins blancs secs et frais"
      },
      foodPairing: "Poissons, fruits de mer, volailles, cuisine insulaire"
    }
  }
}); 